import React, { useState } from 'react'
import Text from '../../../../../Text'
import { Collapse } from '@mui/material'
import ChevronDownIconCollapsible from '../../../../../icons/ChevronDownIconCollapsible'
import styles from './styles.module.css'
import SpecsTable from '../SpecsTable'

function SpecsCollapsible({ category, specs, theme }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <div className={styles.title} onClick={() => setExpanded(!expanded)}>
        <Text type="heading-8">{category}</Text>
        <div className={styles.collapsibleIcon}><ChevronDownIconCollapsible/></div>
      </div>
      <Collapse in={expanded} timeout={{ enter: 500, exit: 250 }}>
        <SpecsTable specs={specs} theme={theme}/>
      </Collapse>
    </>
  )
}

export default SpecsCollapsible
